import { createFileRoute } from '@tanstack/react-router'

import { TopicPage } from '@/topic/components/TopicPage/TopicPage'
import { TopicPageContent } from '@/topic/components/TopicPageContent/TopicPageContent'

export const Route = createFileRoute('/_learning/courses/$topic')({
  component: RouteComponent,
})

function RouteComponent() {
  const params = Route.useParams()

  return (
    <TopicPage>
      <TopicPageContent context="courses" topicSlug={params.topic} />
    </TopicPage>
  )
}
